import axios from "axios";

export const getGoalComments = async (goalId, token, page) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/getGoalComments/${goalId}&page=${page}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
